import React from 'react';
import TopNav from '../../components/TopNav';
import CatchRegister from '../../images/catch/catch_register.jpg';
import CatchRegister2x from '../../images/catch/catch_register@2x.jpg';

const Header = () => {
  return (
    <header>
      <TopNav />
      <div className="catch sub">
        <img
          src={ CatchRegister }
          srcSet={ `${ CatchRegister } 1x, ${ CatchRegister2x } 2x` }
          alt="新規登録"
        />
      </div>
    </header>
  );
}

export default Header;
